import FormattedMessage from 'I18n/components/FormattedMessage';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AiSummaryCard({
  maxHeight,
  aiAnswer
}) {
  const theme = useTheme();
  return (
    /*#__PURE__*/
    // @ts-expect-error gridColumn is valid
    _jsx(CardWrapper, {
      compact: true,
      gridColumn: "span 2",
      children: /*#__PURE__*/_jsx(CardSection, {
        blockSize: "100%",
        children: /*#__PURE__*/_jsxs(ExpandableText, {
          maxHeight: maxHeight - parseInt(theme.space['600'], 10) * 2,
          children: [/*#__PURE__*/_jsxs(Flex, {
            justifyContent: "space-between",
            marginBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-25",
              textTransform: "uppercase",
              color: "text-core-subtle",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.searchResults.summarizedWithAi"
              })
            }), /*#__PURE__*/_jsx(AIBadge, {})]
          }), aiAnswer]
        })
      })
    })
  );
}